<template>
  <div>
    <el-dialog
      ref="viewChatRoomDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="微信群信息"
            name="basic"
          >
            <div class="modal-box">
              <h3 class="modal-title">
                基础信息
              </h3>
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="微信群号">
                      <el-input
                        v-model="dialogViewForm.wxId"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="微信群名称">
                      <el-input
                        v-model="dialogViewForm.name"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="省区">
                      <el-input
                        v-model="dialogViewForm.provinceName"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="覆盖市场">
                      <el-input
                        v-model="dialogViewForm.market"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="群成员人数">
                      <el-input-number
                        v-model="dialogViewForm.memberNumber"
                        :controls="false"
                        style="width: 100%;"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="注册人数">
                      <el-input-number
                        v-model="dialogViewForm.enrollment"
                        :controls="false"
                        style="width: 100%;"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="认证数量">
                      <el-input-number
                        v-model="dialogViewForm.certifiedNumber"
                        :controls="false"
                        style="width: 100%;"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="线下运维数量">
                      <el-input-number
                        v-model="dialogViewForm.maintainNumber"
                        :controls="false"
                        style="width: 100%;"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="群主">
                      <el-input
                        v-model="dialogViewForm.groupOwner"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="群创建人">
                      <el-input
                        v-model="dialogViewForm.createBy"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态">
                      <el-radio-group
                        v-model="dialogViewForm.status"
                        disabled
                      >
                        <el-radio :label="1">
                          正常
                        </el-radio>
                        <el-radio :label="2">
                          已解散
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>

            <div class="modal-box">
              <h3 class="modal-title">
                备注信息
              </h3>
              <div class="modal-row-box">
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item prop="remark">
                      <el-input
                        v-model="dialogViewForm.remark"
                        type="textarea"
                        disabled
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane
            label="群成员清单"
            name="memberOrder"
          >
            <div class="modal-box">
              <el-table
                :data="memberDataList"
                border
                stripe
                :header-cell-style="{background:theme()}"
                :cell-style="memberTableCellStyle"
                style="width: 100%;"
                :height="tableCustomHeight"
                class="data-table"
              >
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  fixed
                  width="55"
                />
                <el-table-column
                  label="成员头像"
                  align="center"
                  fixed
                  width="85"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.smallHeadImgUrl"
                      class="img-size"
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(column, index) in memberTableColumns"
                  :key="index"
                  resizable
                  show-overflow-tooltip
                  :width="column.width ? column.width : ''"
                  :label="column.label"
                  :prop="column.prop"
                  :align="column.align || ''"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row[column.prop] }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane
            label="微信群成员进出日志清单"
            name="memberInOutLogs"
          >
            <div class="modal-box">
              <el-table
                v-if="activeName === 'memberInOutLogs'"
                :data="logsDataList"
                border
                stripe
                :header-cell-style="{background:theme()}"
                style="width: 100%;"
                class="data-table"
              >
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  fixed
                  width="55"
                />
                <el-table-column
                  v-for="(column, index) in logsTableColumns"
                  :key="index"
                  resizable
                  show-overflow-tooltip
                  :width="column.width ? column.width : ''"
                  :label="column.label"
                  :prop="column.prop"
                  :align="column.align || ''"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row[column.prop] }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 微信群API
import { viewWeChatGroupApi } from '@/api/v2/weChatGroup'
// 微信群成员API
import { listWeChatGroupMemberApi } from '@/api/v2/weChatGroupMember'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      activeName: 'basic',
      tableCustomHeight: 520,
      memberTableColumns: [
        { label: '成员类别', prop: 'typeValue', width: 100 },
        { label: '成员微信号', prop: 'userName', width: 150 },
        { label: '成员昵称', prop: 'nickname', width: 150 },
        { label: '成员群昵称', prop: 'userRemark', width: 150 },
        { label: '腾讯问卷用户ID', prop: 'questionnaireUserId', width: 180 },
        { label: '问卷专卖证号', prop: 'questionnaireCertificateNo', width: 130 },
        { label: '问卷店名', prop: 'questionnaireStoreName', width: 150 },
        { label: '问卷档位', prop: 'questionnaireStoreLevel', width: 120 },
        { label: '腾讯问卷用户匹配时间', prop: 'questionnaireMatchTime', width: 150 },
        { label: '零售户专卖证号', prop: 'storeCertificateNo', width: 130 },
        { label: '零售户店名', prop: 'certificatedStoreName', width: 150 },
        { label: '零售户档位', prop: 'storeLevel', width: 120 },
        { label: '零售户维护情况', prop: 'storeStatusValue', width: 120 },
        { label: '小程序用户OpenID', prop: 'wxOpenId', width: 150 },
        { label: '成员手机号', prop: 'phone', width: 120 },
        { label: '成员状态', prop: 'statusValue', width: 90 },
      ],
      logsTableColumns: [
        { label: '日志信息', prop: 'content' },
        { label: '日志时间', prop: 'operationTime', width: 150 },
      ],
      dialogViewForm: {},
      memberDataList: [],
      logsDataList: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.activeName = 'basic';
        _this.dialogViewForm = {};
        _this.memberDataList = [];
        _this.logsDataList = [];

        _this.loadWeChatGroupData()
        _this.loadChatGroupMemberData()

        _this.$nextTick(() => {
          const dialogHeight = _this.$refs.viewChatRoomDialog.$el.offsetHeight
          if (dialogHeight) {
            _this.tableCustomHeight = (dialogHeight - 266);
          } else {
            _this.tableCustomHeight = 520;
          }
          _this.$refs.viewMemberTable.doLayout();
        })
      }
    }
  },
  methods: {
    theme () {
      return '#0076ff'
    },
    memberTableCellStyle ({ row }) {
      let style = {};
      if (row.status === 2) {
        style.color = 'red'; // 红色字体
        style.textDecoration = 'line-through'; // 删除线
      }
      return style;
    },
    // 加载数据
    loadWeChatGroupData () {
      let _this = this;
      viewWeChatGroupApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;
        _this.logsDataList = data.groupInOutLogsDtoList || [];

        // 设置小程序码图片
        // _this.appletCodeImgList.push({
        //   name: '微信群零售户认证小程序码',
        //   url: process.env.VUE_APP_FILE_V2_API + data.appletCodeImg,
        //   attachmentName: '微信群零售户认证小程序码',
        //   attachmentUrl: data.appletCodeImg
        // })
        // _this.appletCodeImgUrl = process.env.VUE_APP_FILE_V2_API + data.appletCodeImg
      })
    },
    // 获取微信群成员清单数据
    loadChatGroupMemberData () {
      let _this = this;
      listWeChatGroupMemberApi({ groupId: _this.dataId }).then((response) => {
        const { data } = response;
        _this.memberDataList = data || [];
      })
    },
    // 下载小程序码图片
    downloadAppletCodeImage (src, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        }); // 创建一个单击事件
        a.download = name || "小程序码"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = src;
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
}
::v-deep .el-table {
  font-size: 12px;
  th {
    color: #ffffff;
  }
  .cell {
    line-height: 16px;
  }
}

.data-table {
  .img-size {
    width: 62px;
    height: 62px;
    vertical-align: middle;
  }
}
</style>
